export default __webpack_public_path__ + "static/media/Front-Sky-Blue-Resort.26cc919b.jpg";